/**
 * A2A Tenant Helper
 * Provides tenant ID extraction and conversion for multi-tenant A2A operations
 */

/**
 * Map tenant ID strings to actual UUID tenant IDs
 */
const tenantIdMap = {
  'tn_01': 'eadcd263-a399-4261-8cbd-8fb1ce6da0e3',
  'tn_02': '1acd60af-8884-48bb-b1ea-13fbb935d3a8',
  'tn_03': 'adf83c8b-b623-4f69-b65f-25e11c2781ce'
};

/**
 * Get the actual UUID tenant ID from various formats
 * @param {string|Object} userOrTenantId - User object or tenant ID string
 * @returns {string} UUID tenant ID
 */
export function getTenantId(userOrTenantId) {
  let tenantId = null;

  // If it's a user object, extract tenant_id
  if (userOrTenantId && typeof userOrTenantId === 'object') {
    tenantId = userOrTenantId?.tenant_id || 
               userOrTenantId?.tenantId || 
               userOrTenantId?.user?.tenant_id || 
               userOrTenantId?.user?.tenantId;
  } else if (typeof userOrTenantId === 'string') {
    tenantId = userOrTenantId;
  }

  // If tenantId is a mapped string (like 'tn_01'), convert to UUID
  if (tenantId && tenantIdMap[tenantId]) {
    return tenantIdMap[tenantId];
  }

  // If it's already a UUID, return as is
  if (tenantId && tenantId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
    return tenantId;
  }

  // Default fallback to tn_01 UUID
  console.warn('[A2A Tenant] No valid tenant ID found, using default tn_01');
  return tenantIdMap['tn_01'];
}

/**
 * Get tenant ID from current user with fallback
 * @param {Object} currentUser - Current user object
 * @returns {string} UUID tenant ID
 */
export function getTenantIdFromUser(currentUser) {
  if (!currentUser) {
    console.warn('[A2A Tenant] No currentUser provided, using default tenant');
    return tenantIdMap['tn_01'];
  }

  return getTenantId(currentUser);
}

